import { rankWith, uiTypeIs } from '@jsonforms/core'
import { UI_TYPE_RANK } from './ranks'

// Tells Jsonforms which control/component should be used.
export default rankWith(UI_TYPE_RANK, uiTypeIs('TextWithCopy'))
